import { t } from "i18next";
import { Attachment, FinalCost, Province } from "../types/canvasTypes";
import { MaterialNameMap } from "../types/materialList";
import { isAuthorized } from "../util/whitelist";
import { useCurrentUser } from "../context/UserContext";

type QuotationTableProps = {
  province: Province;
  selectedLength: number;
  finalCost: FinalCost[];
  materialOption: string;
  material: Attachment[];
  totalCost: number;
};

const QuotationTable = ({
  province,
  selectedLength,
  finalCost,
  materialOption,
  material,
  totalCost,
}: QuotationTableProps) => {
  const { currentUser } = useCurrentUser();

  const isAuth = isAuthorized(currentUser) || province === Province.Quebec;

  return (
    <div id="sidesInformation">
      <div>
        <table className="quotation-table">
          <tbody>
            <tr>
              <th>
                <div className="table-headline">{t("glass")}</div>
              </th>
              <th>{t("quantity")}</th>
              <th>{t("pricePerUnit")}</th>
              <th style={{ textAlign: "end" }}>total</th>
            </tr>

            {finalCost.map((cost, index) => {
              return (
                cost.total > 0 && (
                  <tr key={index}>
                    <td>
                      {cost.isDoor ? "Door" : ""}
                      {selectedLength} x {cost.length}"
                      {cost.isRPannel ? "R" : ""}
                    </td>
                    <td>{cost.total}</td>
                    {isAuth && <td>{cost.price.get(province)!}$</td>}
                    {isAuth && (
                      <td style={{ textAlign: "end" }}>
                        {cost.price.get(province)! * cost.total}$
                      </td>
                    )}
                  </tr>
                )
              );
            })}
            <div className="table-headline">
              Material
              <span
                style={{
                  fontSize: "15px",
                  color: "black",
                  fontWeight: 400,
                }}
              >
                ({materialOption})
              </span>
            </div>
            {material.map((material, index) => {
              return (
                material.count > 0 && (
                  <tr key={index}>
                    <td>
                      {MaterialNameMap.get(material.material)?.get(province)}
                    </td>
                    <td>{material.count}</td>
                    {isAuth && (
                      <td>
                        {materialOption === "Stainless"
                          ? material.costSilver.get(province)!
                          : material.costBlack.get(province)!}
                        $
                      </td>
                    )}
                    {isAuth && (
                      <td style={{ textAlign: "end" }}>
                        {material.count *
                          (materialOption === "Stainless"
                            ? material.costSilver.get(province) || 0
                            : material.costBlack.get(province) || 0)}
                        $
                      </td>
                    )}
                  </tr>
                )
              );
            })}
            {isAuth && <div className="table-headline">Total</div>}

            {isAuth && (
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td
                  style={{
                    fontSize: "20px",
                    fontWeight: "800",
                    textAlign: "end",
                  }}
                >
                  {totalCost}$ + tx
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default QuotationTable;
